import axios from 'axios'

export default {
  namespaced: true,

  actions: {
    sendTokenToServer({
      commit
    }, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/request/web/registerWebBrowser",
          data: obj,
          method: 'POST'
        }).then(response => {
          if (response.data.status) {
            commit("updateFirebaseToken", {
              token: obj.browserToken
            }, {
              root: true
            })
            localStorage.setItem("fToken", obj.browserToken);
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    sendGroups(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/request/web/registerGroupsToBrowser",
          data: obj,
          method: "POST"
        }).then(response => {
          if (response) {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    getGroups() {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/request/web/getGroupsByWeb",
          method: "GET"
        }).then(response => {
          if (response.data.status) {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    send(o, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/request/web/fromRequested?id=" + id + "&target=C",
          method: "PUT"
        }).then(response => {
          if (response.data.status) {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    isEnableWeb() {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/request/web/isEnableWeb",
          method: "POST"
        }).then(response => {
          if (response.data.status) {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    stopVisor() {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/request/web/suppressWebBrowser",
          method: "POST"
        }).then(response => {
          if (response.data.status) {
            resolve(response);
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    resetTransactions(o) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/request",
          method: "DELETE"
        }).then(response => {
          if (response.data.status) {
            resolve(response);
          }
          reject(response);
        }).catch(error => {
          reject(error)
        })
      })
    },
    getLastGroups() {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/request/web/findLastEnabledGroups",
          method: "GET"
        }).then(response => {
          if (response) {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
}